import React,{useState,useEffect,useRef} from "react";
import { Trans, useTranslation} from 'react-i18next'
import './ReleaseMusic.css'
import UploadCoverArt from './../../../../images/uploadcoverart.png'
import {useLocation,useNavigate} from "react-router-dom";
import { useJwt, decodeToken } from "react-jwt";
import Cookies from "universal-cookie";

function AlbumPhoto({pagePath,setPagePath,albumImage,setAlbumImage}) {
    const ref = useRef(null)
    const inputRef = useRef(null)
    const {t, i18n } = useTranslation();
    const [albumImageError,setAlbumImageError] = useState(false)
    const [ImageDragActive , setImageDragActive] = useState(false)
    const navigate = useNavigate();
    const cookies = new Cookies(null ,{ path: '/' });
    const location = useLocation();

    const onButtonClick = () => {
      inputRef.current.click();
    };

    const handleImageDrag = (e) =>{
      e.preventDefault();
      e.stopPropagation();

      if (e.type === "dragenter" || e.type === "dragover") {
          setImageDragActive(true);
        } else if (e.type === "dragleave") {
          setImageDragActive(false);
        }
  }

  useEffect(()=>{
    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
      setPagePath("/Dashboard/releasemusic/uploadphoto")
   }

   if(decodeToken(cookies.get('token')).info.role==="label"){
      setPagePath("/dashboard/label/releasemusic/uploadphoto")
   }
  },[])

  {/** Drag drop funtions */}


  const resizeImage = (file, callback) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
  
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
  
      // Set canvas size to 4000x4000 pixels
      canvas.width = 4000;
      canvas.height = 4000;
  
      // Draw the image onto the canvas with 4000x4000 dimensions
      ctx.drawImage(img, 0, 0, 4000, 4000);
  
      // Convert the canvas to a Blob or Data URL and pass it to the callback
      canvas.toBlob((blob) => {
        const resizedFile = new File([blob], file.name, { type: file.type });
        callback(resizedFile);
      }, file.type);
    };
  };

  const handleImageDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setImageDragActive(false);
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        var filelist=[]
        console.log(e.dataTransfer.files[0]);
        const img = new Image(); 
        img.src = URL.createObjectURL(e.dataTransfer.files[0])
  
        img.onload = () => {
          console.log(img.height);
          console.log(img.width);
          console.log(img);
          if(img.height!==img.width){
            // CHANGE THIS IF REQUIRED
            // setAlbumImageError(true)
            urlToFile(img.src).then((file)=>{
              resizeImage(file, (resizedFile) => {
                setAlbumImage([resizedFile]);
                setAlbumImageError(false);
              });
            })
           
          }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
            // CHANGE THIS IF REQUIRED
            // setAlbumImageError(true)
            urlToFile(img.src).then((file)=>{
              resizeImage(file, (resizedFile) => {
                setAlbumImage([resizedFile]);
                setAlbumImageError(false);
              });
            })
            // resizeImage(e.dataTransfer.files[0], (resizedFile) => {
            //   setAlbumImage([resizedFile]);
            //   setAlbumImageError(false);
            // });
          }else{
            setAlbumImageError(false)
            // filelist.push(e.dataTransfer.files[0])
            setAlbumImage([e.dataTransfer.files[0]])
          }
        }

      
 
        }
        
  };

  const urlToFile = async (imageUrl, filename = "image.jpeg") => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
};

  const handleImageChange = (e) => {
      e.preventDefault();
      if (e.target.files && e.target.files[0]) {
        const filelist = []
        const img = new Image(); 
        img.src = URL.createObjectURL(e.target.files[0])
        img.onload = () => {
          console.log(img.height);
          console.log(img.width);
          if(img.height!==img.width){
            // CHANGE THIS IF REQUIRED
            // setAlbumImageError(true)
            resizeImage(e.target.files[0], (resizedFile) => {
              setAlbumImage([resizedFile]);
              setAlbumImageError(false);
            });
          }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
             // CHANGE THIS IF REQUIRED
            // setAlbumImageError(true)
            resizeImage(e.target.files[0], (resizedFile) => {
              setAlbumImage([resizedFile]);
              setAlbumImageError(false);
            });
          }else{
            setAlbumImageError(false)
            // filelist.push(e.target.files[0])
            setAlbumImage([e.target.files[0]])
          }
        }
        // for(var i=0;i<e.target.files.length;i++){
        //   const img = new Image(); 
        //   img.src = URL.createObjectURL(e.target.files[0])
        //   img.onload = () => {
        //     console.log(img.height);
        //     console.log(img.width);
        //     if(img.height!==img.width){
        //       setAlbumImageError(true)
        //     }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
        //       setAlbumImageError(true)
        //     }else{
        //       setAlbumImageError(false)
        //       // filelist.push(e.target.files[0])
        //       setAlbumImage(e.target.files[0])
        //     }
        //   }
        // }
      }
  };

    return (
      
         
        <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
             <div className="AddMusicHeader"> {t('Addcoverart')}</div>
       
             
            <div className="AddMusicDesc">Image must be 3000x3000px - 6000x6000px in size, 72 dpi, 1:1 aspect ratio, in JPEG or PNG format.</div>
             

             {
              albumImageError &&
              <div className="AddMusicDesc" style={{color:'#FF8686'}}>Selected image does not meet the specified format requirements.<br/>Image must be 3000x3000px - 6000x6000px in size, 72 dpi, 1:1 aspect ratio, in JPEG or PNG format.</div>
             }
{/* 
            {
               albumImage.length!==0 && cookies.get('lang') === 'en' &&
              <div className="AddMusicDesc">{t('Replaceorcontinue')}</div>
             }  

            {
               albumImage.length!==0 && cookies.get('lang') === 'jp' &&
              <div className="AddMusicDesc" style={{color:"#C7A5FF"}}>{t('Replaceorcontinue')}</div>
             }   */}

            {
               albumImage.length===0 &&
               <form id="form-file-upload2" style={{cursor:'pointer'}} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
               <input ref={inputRef} type="file"  id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                 <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : "" }>
                     <div className="CoverPicUpload" style={{backgroundImage:`url(${UploadCoverArt})`}}>
                       <span className="CoverartText"> 
                       <Trans i18nKey="Dragordrop" components={{1:<br/>}} >
                       Drag and Drop your files here <br/> or 
                      </Trans>
                           <button className="upload-button" onClick={onButtonClick} style={{color:'#C7A5FF',textDecoration:'underline'}}>
                           {t('Browseyourfiles')} 
                                 </button> 
                       </span>
                     </div>
                 </label>
             { ImageDragActive && <div id="drag-file-element" onDragEnter={handleImageDrag} onDragLeave={handleImageDrag} onDragOver={handleImageDrag} onDrop={handleImageDrop}></div> }
             </form>
            }
          

          {
            albumImage.length!==0 &&
            <form id="form-file-upload2" style={{cursor:'pointer',display:'flex',flexDirection:'column',marginTop:'4em'}} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
            <input ref={inputRef} type="file"  style={{backgroundColor:'pink'}} id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
              <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : "" }>

                {/** PENDING */}
                <img src={URL.createObjectURL(albumImage[0])} style={{width:'25em',height:'25em',marginTop:'2.5em'}}/>
              {/* {
                sharedData.image_url===undefined &&
                <img src={URL.createObjectURL(albumImage[0])} style={{width:'25em',height:'25em',marginTop:'2.5em'}}/>
              } */}
               {/* {
                sharedData.image_url!==undefined &&
                <img src={URL.createObjectURL(albumImage[0])} style={{maxWidth:'25em',maxHeight:'25em',marginTop:'2.5em'}}/>
              } */}
                 
                  <div className="ReplaceImgTxt">Replace image</div>
              </label>
            
          { ImageDragActive && <div id="drag-file-element" onDragEnter={handleImageDrag} onDragLeave={handleImageDrag} onDragOver={handleImageDrag} onDrop={handleImageDrop}></div> }
          </form>

          }

        {/* {
            albumImage.length!==0 &&
            <div className="ReplaceImgTxt">Replace image</div>
        } */}

            

            <div style={{display:'flex',flexDirection:'row',marginTop:'3.5em',paddingBottom:'4em'}}>
              <div className="BackBtn2" onClick={()=>{
                 if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                  navigate("/Dashboard/releasemusic/uploadtracks")
                }
      
                if(decodeToken(cookies.get('token')).info.role==="label"){
                  navigate("/dashboard/label/releasemusic/uploadtracks")
                }
                
                }}>
              {t('Back')} 
              </div>
              {
                    albumImage.length!==0 &&
                    <div className="NextBtn2" onClick={()=>{
                      if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                        navigate("/Dashboard/releasemusic/albumdetails")
                      }
            
                      if(decodeToken(cookies.get('token')).info.role==="label"){
                        navigate("/dashboard/label/releasemusic/albumdetails")
                      }
                      }}>
                        <div className="PostLoginBtnOverlay"/>
                    {t('Next')}  
                    </div>
              }

              {
                    albumImage.length===0 &&
                    <div className="NextBtn2" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                    {t('Next')}  
                    </div>
              }
              
            </div>
        </div> 
    );
}

export default AlbumPhoto;